export default __webpack_public_path__ + "1623944257a53137bd444485696e8278.jpg";